/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { CHAT: de },
  'el-GR': { CHAT: el },
  'en-US': { CHAT: en },
  'es-ES': { CHAT: es },
  'fi-FI': { CHAT: fi },
  'fr-FR': { CHAT: fr },
  'it-IT': { CHAT: it },
  'pl-PL': { CHAT: pl },
  'pt-PT': { CHAT: pt }
};
